import useSlingApi from '@sdk/api/useSlingApi';
import { useMutation } from '@tanstack/react-query';
import { TaskInstancePayload } from '@sdk/shiftTasks/types/apiTypes';

import { useShiftTasksBridge } from '@web/shiftTasks/ShiftTasksBridgeProvider/ShiftTasksBridgeProvider';

export function useEditTaskInstance(id: ID) {
  const { shiftTasks } = useSlingApi();
  const shiftTasksBridge = useShiftTasksBridge();

  const mutation = useMutation({
    mutationFn: async (payload: TaskInstancePayload) => {
      const result = await shiftTasks.editInstance(id, payload);
      // Angular expects API type, but we will probably need mapping here at some point
      return result.data;
    },
    onSuccess: (response) => {
      shiftTasksBridge.onEditTaskInstance(response);
    },
  });

  return mutation;
}
